import { Grid, Tab, Tabs } from '@material-ui/core'
import React, { useState } from 'react'
import { useStyles } from './work-list-tabs'
import { wlViewTabs } from './const'
import { a11yProps } from 'asterX-UI/Tabs'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { HOLD, MISSED, SUCCESS } from 'constants/deals'

export const WorkListTabs = () => {
  const classes = useStyles()

  const {
    store: { wlData },
    actions: { handleApproveDiscount, handleUpdateStatus }
  } = useWorkListViewRopStore()

  const [tab, setTab] = useState(0)
  const [declineDiscountOpen, setDeclineDiscountOpen] = useState(false)
  const [acceptDiscountOpen, setAcceptDiscountOpen] = useState(false)
  const [changeToHoldOpen, setChangeToHoldOpen] = useState(false)
  const [changeToMissedOpen, setChangeToMissedOpen] = useState(false)

  const TabBody = wlViewTabs[tab].component

  return (
    <Grid container>
      <Grid item container style={{ marginBottom: 24 }}>
        <Tabs
          className={classes.wlViewTabs}
          value={tab}
          variant="scrollable"
          onChange={(e, value) => setTab(value)}
        >
          {wlViewTabs.map(({ label }, i) => (
            <Tab
              key={`wl-view-tab-${i}`}
              label={label}
              value={i}
              {...a11yProps(i)}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item container>
        <TabBody {...(wlData || {})} />
      </Grid>
      {tab === 0 && wlData?.saleStatusTrack?.code == '90' && (
        <Grid
          item
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={3}
          style={{ marginTop: 20 }}
        >
          <Grid item xs={12}>
            <AsterButton
              fullWidth
              color="negative"
              onClick={() => setDeclineDiscountOpen(true)}
            >
              Отказать в согласовании
            </AsterButton>
          </Grid>
          <Grid item xs={12}>
            <AsterButton
              fullWidth
              color="primary"
              onClick={() => setAcceptDiscountOpen(true)}
            >
              Согласовать скидку
            </AsterButton>
          </Grid>
        </Grid>
      )}
      {tab === 0 &&
        wlData?.saleStatusTrack?.code === '80' &&
        wlData?.saleStatus.code !== SUCCESS && (
          <Grid
            item
            container
            alignItems="center"
            justifyContent="flex-end"
            spacing={3}
            style={{ marginTop: 20 }}
          >
            <Grid item xs={12}>
              <AsterButton
                fullWidth
                color="negative"
                onClick={() => setDeclineDiscountOpen(true)}
              >
                Вернуть в работу
              </AsterButton>
            </Grid>
            <Grid item xs={12}>
              <AsterButton
                fullWidth
                color="primary"
                onClick={() => setAcceptDiscountOpen(true)}
              >
                Согласовать закрытие
              </AsterButton>
            </Grid>
          </Grid>
        )}
      <ActionModal
        open={declineDiscountOpen}
        onClose={() => setDeclineDiscountOpen(false)}
        onCancel={() => setDeclineDiscountOpen(false)}
        onConfirm={() => handleApproveDiscount(false)}
        title="Вы уверены что хотите отказать в согласование скидки ?"
      />

      <ActionModal
        open={acceptDiscountOpen}
        onClose={() => setAcceptDiscountOpen(false)}
        onCancel={() => setAcceptDiscountOpen(false)}
        onConfirm={() => handleApproveDiscount(true)}
        title="Вы уверены что хотите согласовать скидку ?"
      />

      <ActionModal
        open={changeToHoldOpen}
        onClose={() => setChangeToHoldOpen(false)}
        onCancel={() => setChangeToHoldOpen(false)}
        onConfirm={() => handleUpdateStatus(HOLD)}
        title="Вы уверены что хотите вернуть в работу ?"
      />

      <ActionModal
        open={changeToMissedOpen}
        onClose={() => setChangeToMissedOpen(false)}
        onCancel={() => setChangeToMissedOpen(false)}
        onConfirm={() => handleUpdateStatus(MISSED)}
        title="Вы уверены что хотите cогласовать закрытие ?"
      />
    </Grid>
  )
}
